import React from "react";

const Upload = () => {
  return (
    <svg
      width="20"
      height="28"
      viewBox="0 0 20 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.851911"
        y="20.3742"
        width="19.1585"
        height="18.0605"
        rx="2.44214"
        transform="rotate(-90 0.851911 20.3742)"
        stroke="#023A4A"
        strokeWidth="1.70382"
      />
      <path
        d="M10.4646 10.686C10.143 10.3644 9.62161 10.3644 9.30001 10.686L4.0592 15.9268C3.7376 16.2484 3.7376 16.7698 4.0592 17.0914C4.3808 17.413 4.90222 17.413 5.22383 17.0914L9.88232 12.4329L14.5408 17.0914C14.8624 17.413 15.3838 17.413 15.7054 17.0914C16.027 16.7698 16.027 16.2484 15.7054 15.9268L10.4646 10.686ZM10.7058 27.625L10.7058 11.2683L9.05881 11.2683L9.05881 27.625L10.7058 27.625Z"
        fill="#023A4A"
      />
      <rect
        x="6.58789"
        y="27.0566"
        width="10"
        height="2.47054"
        transform="rotate(-90 6.58789 27.0566)"
        fill="white"
      />
      <rect
        width="10"
        height="2.47054"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 13.1763 27.0566)"
        fill="white"
      />
    </svg>
  );
};

export default Upload;
